import { useState } from 'react';

import { Button, Divider, Text, toastService } from '@thefarmersfront/kitchen';

import { IRowNode } from 'ag-grid-community';
import { useShallow } from 'zustand/react/shallow';

import { Table } from '~/components/common';

import { useStockReleaseStore } from '~/store';
import { getStockReleaseRegisterGoodsColumnDefs } from '~/utils';

import StockReleaseRegisterFirstStepSearch from './StockReleaseRegisterFirstStepSearch';

import { TypeStockReleaseGoods } from '~/types/stock.types';

import styles from './StockReleaseRegisterFirstStepContent.module.scss';

const StockReleaseRegisterFirstStepContent = ({
  requestGoodsRef,
}: {
  requestGoodsRef: React.MutableRefObject<HTMLDivElement | null>;
}) => {
  const { requestGoods, deleteRequestGoods, applyFullAvailableQuantity, applyFullDefectiveQuantity } =
    useStockReleaseStore(
      useShallow((state) => ({
        requestGoods: state.requestGoods,
        deleteRequestGoods: state.actions.deleteRequestGoods,
        applyFullAvailableQuantity: state.actions.applyFullAvailableQuantity,
        applyFullDefectiveQuantity: state.actions.applyFullDefectiveQuantity,
      }))
    );

  const { gridOptions: goodsGridOption, columnDefs: goodsColumnDefs } = getStockReleaseRegisterGoodsColumnDefs();

  const [selectedGoodsRow, setSelectedGoodsRow] = useState<IRowNode<TypeStockReleaseGoods>[]>([]);

  // 반출 요청 상품 삭제 핸들러
  const handleClickDelete = () => {
    deleteRequestGoods(selectedGoodsRow.map(({ rowIndex }) => rowIndex as number));
    toastService.addToast({ message: '삭제되었습니다.' });
  };

  return (
    <>
      <StockReleaseRegisterFirstStepSearch />
      <Divider color="gray100" />
      <div
        ref={(el) => (requestGoodsRef.current = el)}
        className={`${styles['table-section']} ${styles['register-goods-table']}`}
      >
        <div className={styles['table-top-field']}>
          <div className={styles['table-top-left-field']}>
            <Text className={styles['title']} size="xxlarge" weight="bold">
              반출 상품 추가
            </Text>
          </div>
          <div className={styles['table-top-right-field']}>
            <Button
              size="tiny"
              variant="outlined"
              status="error"
              disabled={selectedGoodsRow.length === 0}
              onClick={handleClickDelete}
            >
              삭제
            </Button>
            <Button
              size="tiny"
              variant="outlined"
              color="tertiary"
              disabled={requestGoods.length === 0}
              onClick={applyFullAvailableQuantity}
            >
              가용 재고 전량 반출 적용
            </Button>
            <Button
              size="tiny"
              variant="outlined"
              color="tertiary"
              disabled={requestGoods.length === 0}
              onClick={applyFullDefectiveQuantity}
            >
              불용 재고 전량 반출 적용
            </Button>
          </div>
        </div>
        <div className={styles['table-wrapper']}>
          <Table
            className={styles['table']}
            data={requestGoods}
            options={{
              columnDefs: goodsColumnDefs,
              ...goodsGridOption,
            }}
            rowStatusType="STOCK_RELEASE_REGISTER"
            onSelectionChange={setSelectedGoodsRow}
          />
        </div>
      </div>
    </>
  );
};

export default StockReleaseRegisterFirstStepContent;
